import { Component } from "../../../components/base/Component";
import { ICfa } from "../../../models/ICfa";
import { ComponentFactory } from "../../../services/ComponentFactory";

export class CareersModals extends Component {
	constructor(_element: HTMLElement, _app: ICfa) {
		super(_element, _app);
		this.handleModalPopup();
	}

	handleModalPopup(): void {
		const modalTriggerBtns = this._element.querySelectorAll(
			"button[data-element*='-trigger'], a[data-element*='-trigger']"
		);

		if (modalTriggerBtns && modalTriggerBtns.length > 0) {
			modalTriggerBtns.forEach(modalTriggerBtn => {
				const dataElementValue = modalTriggerBtn.getAttribute("data-element");

				if (dataElementValue && dataElementValue.includes("-trigger")) {
					// Remove "-trigger" and prepend "#"
					const modalBaseName = dataElementValue.replace(/-trigger$/, "");
					const modalId = `#${modalBaseName}`;

					$(modalTriggerBtn).magnificPopup({
						items: {
							src: modalId,
							type: "inline"
						},
						mainClass: ""
					});
				}
			});
		}
	}
}

ComponentFactory.registerComponent("careersModals", CareersModals);
